import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import useFilteredFlightDeals from 'home/hooks/useFilteredFlightDeals'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import FlightDealsCarousel from './FlightDealsCarousel/FlightDealsCarousel'
import Image from 'components/Common/Image'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import { HOME_PAGE_FLIGHT_DEALS_THRESHOLD } from 'hooks/Flights/useCampaignsOrDeals'

interface Props {
  flightDeals: Array<App.FlightDeal>
  flightDealsLoading: boolean
}

function FlightDeals(props: Props) {
  const { flightDeals, flightDealsLoading } = props
  const intl = useIntl()
  const {
    filteredFlightDeals,
    airports,
    defaultAirport,
    selectedAirport,
    setAirport,
    hasMultipleAirlines,
  } = useFilteredFlightDeals({ flightDeals })

  const headingText = useMemo(
    () =>
      intl.formatMessage(
        {
          id: 'Ewcja9xA/P',
          defaultMessage: 'Flights sale with{hasMultipleAirlines, select, true { our partner airlines} other {}}',
          description: 'Flight deals heading with conditional partner airlines text',
        },
        {
          hasMultipleAirlines: hasMultipleAirlines ? 'true' : 'other',
        },
      ),
    [intl, hasMultipleAirlines],
  )

  const carouselTitle = useMemo(
    () =>
      airports.length > 1
        ? intl.formatMessage({
            id: '3OSAG5By2r',
            defaultMessage: 'Limited-time flight offers from',
            description: 'Flight deals carousel title when multiple airports are available',
          })
        : intl.formatMessage({
            id: '/nYB+NtPke',
            defaultMessage: 'Limited-time flight offers',
            description: 'Flight deals carousel title when single airport is available',
          }),
    [intl, airports.length],
  )

  if (filteredFlightDeals.length < HOME_PAGE_FLIGHT_DEALS_THRESHOLD) {
    return null
  }

  return (
    <VerticalSpacer gap={16}>
      <LayoutContainer>
        {!!filteredFlightDeals.length && (
          <Group direction="horizontal" gap={8} verticalAlign="end">
            <Heading variant="heading4">{headingText}</Heading>
            {!hasMultipleAirlines && <Image image={filteredFlightDeals[0].carrier.logo} width={100} alt={`Logo of ${filteredFlightDeals[0].carrier.name}`} />}
          </Group>
        )}
      </LayoutContainer>

      <FlightDealsCarousel
        title={carouselTitle}
        onAirportChange={setAirport}
        airports={airports}
        flightDeals={flightDeals}
        defaultAirport={defaultAirport}
        selectedAirport={selectedAirport}
        loading={flightDealsLoading}
        showLookingForAFlight
        showViewAll
      />
    </VerticalSpacer>
  )
}

export default FlightDeals
